import React, { useContext } from 'react';
import { Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons'
import AppContext from '../context/AppContext'
import dashboardClient from '../utils/dashboardClient'


const styles = {
    select: {
        width: 250
    }
}
/**
 * to select the client
 * @returns {JSX.Element}
 * @constructor
 */
const HeaderSelect = () => {
    const { clientName, setClientName } = useContext(AppContext)
    return (
        <Select
            suffixIcon={
                <SearchOutlined
                    style={{ fontSize: '150%', marginTop: -3 }}
                />
            }
            showSearch
            value={clientName}
            onChange={setClientName}
            style={styles.select}
            options={dashboardClient.getClientList()}
        >
        </Select>
    )
}

export default HeaderSelect